import {
	Drawer,
	DrawerBody,
	DrawerFooter,
	DrawerHeader,
	DrawerOverlay,
	DrawerContent,
	DrawerCloseButton,
	Flex,
	Text,
	Box,
	Spinner,
	Center,
	InputRightElement,
	InputGroup,
	List,
	ListItem,
	Avatar,
	Checkbox,
} from '@chakra-ui/react'
import { MdSearch } from 'react-icons/md'
import React, { useState } from 'react'
import InputText from './../inputText/index'
import { useLanguageContext } from './../../../context/locale.context'
import ButtonCTA from '../button'
import { useQuery } from 'react-query'
import { searchOrgContactsQueryKey } from './../../../utils/queryKeyFactory'
import { searchOrgContactsQuery } from './../../../hooks/activity.hooks'
import { parseJSONString } from '../../../utils/common.util'
import { useDebounce } from '../../../hooks/util.hooks'
import styles from './participantDrawer.module.css'
import SVGIcon from '../../../assets/svgIcons'

const ParticipantDrawer = ({
	isOpen,
	onClose,
	headerText,
	setSelectedParticipant,
	selectedParticipant,
	onSubmit,
}) => {
	const [searchString, setSearchString] = useState('')
	const {
		state: { locale },
	} = useLanguageContext()

	const debounceSearchString = useDebounce(searchString, 200)

	const searchOrgContactsParam = {
		search_string: debounceSearchString,
		limit_value: 50,
	}

	const { data: participantData, isLoading: isLoadingParticipantData } =
		useQuery(
			searchOrgContactsQueryKey.search_string_param(searchOrgContactsParam),
			() => searchOrgContactsQuery(searchOrgContactsParam)
		)

	return (
		<Drawer isOpen={isOpen} placement='right' onClose={onClose} size='md'>
			<DrawerOverlay />
			<DrawerContent>
				<DrawerCloseButton />
				<DrawerHeader>
					<Text fontSize='16px' fontWeight='500'>
						{headerText}
					</Text>
					<InputGroup marginTop='2'>
						<InputText
							type='tel'
							width='100%'
							height='36px'
							fontSize='13px'
							fontStyle='normal'
							fontWeight='500'
							color='#131D0B'
							placeholder={locale['Search user...']}
							_placeholder={{ color: '#5A5A5A' }}
							value={searchString}
							onChange={e => {
								setSearchString(e.target.value)
							}}
							borderRadius='18px'
						/>
						<InputRightElement
							pointerEvents='none'
							color='green.500'
							children={<MdSearch fontSize='25' />}
						/>
					</InputGroup>
				</DrawerHeader>

				<DrawerBody>
					{!isLoadingParticipantData ? (
						<Box display='flex' flexDir='column'>
							<List
								px={1}
								w='full'
								spacing={1}
								overflowY='scroll'
								overflowX='hidden'
							>
								{participantData &&
									(participantData || []).map(participant => {
										const {
											operating_asset_first_name: fname,
											asset_first_name: designation,
											activity_inline_data,
										} = participant
										const contactNo = (
											parseJSONString(activity_inline_data) || {}
										).contact_phone_number
										return (
											<React.Fragment key={participant.contact_asset_id}>
												<ListItem>
													<Flex spacing={2} bg='#ffffffa1' p='5px'>
														<Center position='relative' alignSelf='center'>
															<Avatar
																name={fname.trim()}
																bg='brand.800'
																color='white'
																boxShadow='md'
																size='md'
															/>
														</Center>
														<Box ml={2} flex={1} textAlign='left'>
															<Text
																color='brand.700'
																fontSize='14px'
																fontWeight='500'
																textTransform='capitalize'
															>
																{fname}
															</Text>
															<Text
																color='gray.400'
																fontSize='12px'
																fontWeight='500'
																textTransform='capitalize'
															>
																{designation}
															</Text>
															<Text
																color='brand.700'
																fontSize='12px'
																fontWeight='500'
															>
																{contactNo}
															</Text>
														</Box>

														<Box display='flex'>
															<Checkbox
																colorScheme='white'
																className={styles.participantDrawerCheckbox}
																icon={
																	<SVGIcon
																		iconName='RoundCheckboxIcon'
																		svgProps={{
																			fill: 'white',
																			width: '23',
																			height: '23',
																			viewBox: '0 0 23 23',
																		}}
																	/>
																}
																isChecked={selectedParticipant?.some(
																	asset =>
																		asset.asset_id === participant.asset_id
																)}
																onChange={e => {
																	if (e.target.checked) {
																		setSelectedParticipant(prevState => {
																			return [...prevState, { ...participant }]
																		})
																	} else {
																		setSelectedParticipant(prevState => {
																			let filtered = prevState.filter(
																				item =>
																					participant.asset_id !== item.asset_id
																			)
																			return [...filtered]
																		})
																	}
																}}
															></Checkbox>
														</Box>
													</Flex>
												</ListItem>
											</React.Fragment>
										)
									})}
							</List>
						</Box>
					) : (
						<Center p='10'>
							<Spinner size='lg' color='brand.900' />
						</Center>
					)}
				</DrawerBody>

				<DrawerFooter>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='center'
						flex='1'
					>
						<ButtonCTA
							alignSelf='center'
							variant='idcardButton'
							size='sm'
							fontSize='13px'
							fontWeight='500'
							bg='white'
							onClick={onSubmit}
							isDisabled={selectedParticipant.length > 0 ? false : true}
						>
							{locale['Submit']}
						</ButtonCTA>
					</Box>
				</DrawerFooter>
			</DrawerContent>
		</Drawer>
	)
}

export { ParticipantDrawer }
